const getBasicProfile = (googleUser) => {
  // Handle new authorization code flow where credential might not exist
  if (!googleUser || !googleUser.credential) {
    // Return googleUser as-is if it doesn't have a credential (already decoded)
    return googleUser || {};
  }

  // Handle old ID token flow - decode the JWT
  try {
    return JSON.parse(atob(googleUser.credential.split('.')[1]));
  } catch (error) {
    console.error('Failed to decode Google credential:', error);
    return googleUser || {};
  }
};

export default {
  getBasicProfile
};
